import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
const ConfigContext = /*#__PURE__*/ React.createContext({
    pageUrl: "",
    wordpressUrl: "",
    algoliaConfig: {
        apiKey: "",
        appId: "",
        indexName: ""
    },
    streamPlaylistId: "",
    mapboxAccessToken: "",
    imgixConfig: {
        s3Domain: "",
        proxyDomain: "",
        proxySecureToken: ""
    }
});
export function ConfigProvider(param) {
    let { children , config  } = param;
    return /*#__PURE__*/ _jsx(ConfigContext.Provider, {
        value: config,
        children: children
    });
}
export function ConfigConsumer(param) {
    let { children  } = param;
    return /*#__PURE__*/ _jsx(ConfigContext.Consumer, {
        children: (value)=>children(value)
    });
}
export const useConfig = ()=>useContext(ConfigContext);
